import { MICROSOFT_CLARITY_ALLOWED_DOMAINS } from "../common/constants";

if (MICROSOFT_CLARITY_ALLOWED_DOMAINS.includes(window.location.hostname)) {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "mlj3nlxg9c");
}
